<div class="d-flex align-items-end flex-column h-100">
    <div class="d-flex mt-auto">
        <img src="{{imageLink}}" class="img-max-height-150 border-radius-10 greyscale image-width">
    </div>
    <div class="xsmall-margin-top" *ngIf="htmlBelowImage">
        <div [innerHTML]="htmlBelowImage"></div>
    </div>
</div>
